export default "__VITE_ASSET__vIzDkVnS__"